import { useEffect, useRef, useState } from "react";

// DTOs
import { TabPreco } from "../../dto/TabPreco";
import { FormaCob } from "../../dto/FormaCob";
import { PlanoPagto } from "../../dto/PlanoPagamento";
import { UserInfo } from "../../dto/UserInfo";
import { DadosPedido } from "../../dto/Pedidos";
import { ItemPedido } from "../../dto/ItemPedido";

// Hooks
import { useAgente } from "./agente";
import { useItemPedido } from "./itemPedido";
import { useLoading } from "./loading";

// Helpers
import { mostraMensagemErro } from "../../helpers/Notificacoes";
import { useStatusPedido } from "./statusPedido";


export const usePedido = () => {

    const [userInfo] = useState<UserInfo>(JSON.parse(localStorage.getItem('udbs')!));
    const { agentes, buscouAgentes, agenteSelecionado, setAgenteSelecionado, tabPreco, buscouTabPreco,
        formaCob, buscouFormaCob, planoPagamento, buscouPlanoPgto, modoBloqueado, setModoBloqueado, dadosInvalidos } = useAgente();
    const { itens, buscaItens, buscaItensPedidoItem } = useItemPedido();
    const [erroPedido, setErroPedido] = useState<String | null>(null);
    const [pedidoSelecionado, setPedidoSelecionado] = useState<DadosPedido | null>();
    const [dadosCarregados, setDadosCarregados] = useState(false);
    const [tabPrecoSelecionada, setTabPrecoSelecionada] = useState<TabPreco | null>();
    const [formaCobSelecionada, setFormaCobSelecionada] = useState<FormaCob | null>();
    const [planoPagamentoSelecionado, setPlanoPagamentoSelecionado] = useState<PlanoPagto | null>();
    const [itensSelecionados, setItensSelecionados] = useState<ItemPedido[]>([]);
    const [frete, setFrete] = useState<number>(0);
    const [freteInput, setFreteInput] = useState<string>("");
    const [valorIpi, setValorIpi] = useState<number>(0);
    const [valorIcmsSubst, setValorIcmsSubst] = useState<number>(0);
    const [observacao, setObservacao] = useState<string>('');
    const [totalItens, setTotalItens] = useState<number>(0);
    const [totalPedido, setTotalPedido] = useState<number>(0);
    const [ordemDigitacao, setOrdemDigitacao] = useState<number>(0);
    const proxOrdemDigitacao = useRef<number>(0);

    const [possuiAgente, setPossuiAgente] = useState(false);
    const [agentePossuiTabPreco, setAgentePossuiTabPreco] = useState(false);
    const [agentePossuiPlanoPgto, setAgentePossuiPlanoPgto] = useState(false);
    const [agentePossuiFormaCob, setAgentePossuiFormaCob] = useState(false);
    const [itensPedidoCarregados, setItensPedidoCarregados] = useState(false);

    const { isLoading, setIsLoading, loadingMessage, setLoadingMessage, updateLoadingStage, calculateLoadingProgress, loadingStages } = useLoading();
    const { statusPedidos } = useStatusPedido();
    const carregandoItensRef = useRef(false);

    const descricaoStatusPedido = statusPedidos?.find(item => item.idStatusPedido === pedidoSelecionado?.idStatusPedido)?.descricao;

    async function carregaPedido(pedidoSelecionado: DadosPedido) {

        setLoadingMessage('Preparando dados do pedido...');

        try {
            updateLoadingStage('itens', true);
            setLoadingMessage('Carregando dados do pedido...');
            if (pedidoSelecionado.itens.length === 0) {
                setDadosCarregados(true);
                setItensPedidoCarregados(true);
            } else {
                await buscaItensPedido(pedidoSelecionado);
                updateLoadingStage('itens', false);
            }

            updateLoadingStage('pedidoPreparacao', true);
            setLoadingMessage('Finalizando preparação do pedido...');
            await buscaDadosPedido(pedidoSelecionado);
            updateLoadingStage('pedidoPreparacao', false);

            // setLoadingMessage('Carregando...');
            //console.log("Todas as requisições foram concluídas com sucesso.");
        } catch (error: any) {
            mostraMensagemErro("Erro ao carregar os dados");
        }
    }


    //Busca e seta os dados do pedido selecionado
    const buscaDadosPedido = async (pedidoSelecionado: DadosPedido) => {
        if (!pedidoSelecionado) {
            setDadosCarregados(false);
            setPedidoSelecionado(null);
            return;
        }

        const agentePedido = agentes.find(agente => agente.idAgente === pedidoSelecionado.idAgente!);
        if (!agentePedido) {
            setDadosCarregados(false);
            mostraMensagemErro("Agente não encontrado");
            return;
        }

        setPedidoSelecionado(pedidoSelecionado);
        setAgenteSelecionado(agentePedido);

        const possuiAgente = agentePedido != null;
        setPossuiAgente(possuiAgente);

        const agentePossuiTabPreco = agentePedido?.idTabPreco != null;
        setAgentePossuiTabPreco(agentePossuiTabPreco);

        const agentePossuiPlanoPgto = agentePedido?.idPlanoPagto != null;
        setAgentePossuiPlanoPgto(agentePossuiPlanoPgto);

        const agentePossuiFormaCob = agentePedido?.idFormaCob != null;
        setAgentePossuiFormaCob(agentePossuiFormaCob);

        let tabPrecoPedido;
        let planoPgtoPedido;
        let formaCobPedido;

        if (agentePossuiTabPreco) {
            tabPrecoPedido = tabPreco!.find(tabela => tabela.idTabPreco === agentePedido!.idTabPreco!);
        } else {
            tabPrecoPedido = tabPreco!.find(tabela => tabela.idTabPreco === pedidoSelecionado.idTabPreco!);
        }

        if (agentePossuiPlanoPgto) {
            planoPgtoPedido = planoPagamento.find(planoPgto => planoPgto.idPlanoPagto === agentePedido!.idPlanoPagto!);
        } else {
            planoPgtoPedido = planoPagamento.find(planoPgto => planoPgto.idPlanoPagto === pedidoSelecionado.idPlanoPagto!);
        }

        if (agentePossuiFormaCob) {
            formaCobPedido = formaCob.find(formaCob => formaCob.idFormaCob === agentePedido!.idFormaCob!);
        } else {
            formaCobPedido = formaCob.find(formaCob => formaCob.idFormaCob === pedidoSelecionado.idFormaCob!);
        }

        /*  if (tabPreco) {
             setTabPrecoSelecionada(tabPrecoPedido);
         } */
        setTabPrecoSelecionada(tabPrecoPedido);
        setFormaCobSelecionada(formaCobPedido);
        setPlanoPagamentoSelecionado(planoPgtoPedido);

        const valorFrete = Number(pedidoSelecionado.valorFrete) || 0;
        setFrete(valorFrete);
        setFreteInput(
            valorFrete.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        );

        setValorIpi(parseFloat((Number(pedidoSelecionado.valorIpi)).toFixed(2)));
        setTotalItens(parseFloat((Number(pedidoSelecionado.valorMercadoria)).toFixed(2)));
        setValorIcmsSubst(parseFloat((Number(pedidoSelecionado.valorIcmsSubst)).toFixed(2)));

        setObservacao(pedidoSelecionado.observacaoInterna || '');
        setTotalPedido(parseFloat((Number(pedidoSelecionado.total)).toFixed(2)));
    }

    useEffect(() => {
        const maiorOrdem =
            itensSelecionados.length > 0
                ? Math.max(...itensSelecionados.map(i => i.ordemDigitacao)) + 1
                : 1;

        proxOrdemDigitacao.current = maiorOrdem;
    }, [itensPedidoCarregados, itensSelecionados]);


    //Verifica se houve alteração de tabela de preço e atualiza a lista de itens de acordo 
    useEffect(() => {
        const buscaItensAtualizados = async () => {

            await buscaItens(tabPrecoSelecionada?.idTabPreco! || null);
        }

        buscaItensAtualizados()
    }, [tabPrecoSelecionada]);


    const buscaItensPedido = async (pedido: DadosPedido) => {
        if (itensPedidoCarregados || carregandoItensRef.current) return;
        //variavel de controle
        carregandoItensRef.current = true;

        if (pedidoSelecionado && itens.length > 0 && pedidoSelecionado!.itens.length > 0) {
            const itenspedido: ItemPedido[] = await buscaItensPedidoItem(pedido.idPedido);

            setDadosCarregados(true);
            setItensPedidoCarregados(true);
            setItensSelecionados(itenspedido);
        }

        carregandoItensRef.current = false;
    };

    //Recebe o item do pedido e seta os dados do mesmo
    function handleSetItemPedido(itemPedido: ItemPedido) {

        itemPedido.idEmpresa = userInfo.idEmpresa;

        const itemTabela = itens.find(item => item.idItem === itemPedido.idItem);
        if (!itemTabela) {
            mostraMensagemErro("item não existe na tabela selecionada");
            return;
        }

        const ativo = itemTabela.ativo;
        const unidade = itemTabela.codUnidade;
        const descricao = itemTabela.descricao;
        const valor = itemTabela.valor > 0 ? parseFloat(Number(itemTabela.valor).toFixed(4)) : parseFloat(Number(itemPedido.valor).toFixed(4));
        const qtd = Number(itemPedido.qtd);
        const percIpi = Number(itemTabela.percIpi || 0);
        const valorTotal = parseFloat((valor * qtd).toFixed(2));
        const valorIpi = parseFloat((percIpi * (valorTotal / 100)).toFixed(2));

        const ordem = proxOrdemDigitacao.current++;

        const item = { ...itemPedido };
        item.descricao = descricao;
        item.ativo = ativo;
        item.valor = valor;
        item.qtd = qtd;
        item.percIpi = percIpi;
        item.total = valorTotal;
        item.valorIpi = valorIpi;
        item.idItemPedido = itemPedido?.idItemPedido || null;
        item.idPedido = '';
        item.idItem = itemPedido.idItem;
        item.ordemDigitacao = ordem;
        item.codUnidade = unidade;
        item.codItem = itemTabela.codItem;

        setOrdemDigitacao(ordem);
        setItensSelecionados((prevItems) => [...prevItems, item]);
        setTotalItens((prevTotal) => parseFloat((Number(prevTotal || 0) + valorTotal).toFixed(2)));
        //setValorIpi((prevTotal) => parseFloat((Number(prevTotal || 0) + valorIpi).toFixed(2)));
    }

    return {
        erroPedido,
        dadosCarregados,
        pedidoSelecionado,
        descricaoStatusPedido,
        agentes,
        buscouAgentes,
        agenteSelecionado,
        setAgenteSelecionado,
        possuiAgente,
        tabPreco,
        buscouTabPreco,
        tabPrecoSelecionada,
        setTabPrecoSelecionada,
        agentePossuiTabPreco,
        setAgentePossuiTabPreco,
        formaCob,
        buscouFormaCob,
        formaCobSelecionada,
        setFormaCobSelecionada,
        agentePossuiFormaCob,
        setAgentePossuiFormaCob,
        planoPagamento,
        buscouPlanoPgto,
        planoPagamentoSelecionado,
        setPlanoPagamentoSelecionado,
        agentePossuiPlanoPgto,
        setAgentePossuiPlanoPgto,
        buscaItensPedidoItem,
        //carregaItensDoPedido,
        handleSetItemPedido,
        itensSelecionados,
        setItensSelecionados,
        itensPedidoCarregados,
        setItensPedidoCarregados,
        ordemDigitacao,
        setOrdemDigitacao,
        observacao,
        setObservacao,
        frete,
        setFrete,
        freteInput,
        setFreteInput,
        valorIpi,
        setValorIpi,
        valorIcmsSubst,
        totalItens,
        setTotalItens,
        totalPedido,
        setTotalPedido,
        carregaPedido,
        isLoading,
        setIsLoading,
        loadingMessage,
        loadingStages,
        calculateLoadingProgress,
        buscaItensPedido,
        modoBloqueado,
        setModoBloqueado,
        dadosInvalidos
    }
}
